import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

/**
 * This service communicates with backend to handle email sending.
 */
@Injectable({
  providedIn: 'root'
})
export class EmailService {
  private http = inject(HttpClient);

  url = environment.apiUrl + '/email';

  /**
   * Sends a base-64 encoded PDF over email.
   * @param base64EncodedPdf pdf data, encoded in base-64.
   * @param pdfName the name of the PDF.
   * @param recipients a list of emails that should receive an email.
   */
  sendEmail(base64EncodedPdf: string, pdfName: string, recipients: string[]) {
    return this.http.post(this.url, {
      base64EncodedPdf,
      pdfName,
      recipients
    });
  }
}
